<template>
    <el-header class="ace-page-header" height="8rem">
        <h6>{{ menuName }}</h6>

        <el-dropdown>
            <div class="el-dropdown-link">
                {{ userInfo.userName }}
                <el-icon class="el-icon--right">
                    <arrow-down/>
                </el-icon>
            </div>
            <template #dropdown>
                <el-dropdown-menu>
                    <router-link :to="{name: 'SignOut'}">
                        <el-dropdown-item>로그아웃</el-dropdown-item>
                    </router-link>
                </el-dropdown-menu>
            </template>
        </el-dropdown>
    </el-header>
</template>

<style lang="scss" scoped>
@import '~@/assets/css/notoSansCJKkr.scss';

.qr-dialog-wrap {
    position: fixed;
    left: 0rem;
    top: 0rem;
    height: 100vh;
    width: 100vw;
    z-index: 10000;
    background-color: #ffffff;

    .qr-code-wrap {
        padding: 5.7rem 5% 6.6rem;

        .qr-code {
            padding-top: 10rem;
            display: flex;
            justify-content: center;
            align-items: center;
        }

        .qr-timer {
            @include subtitle-r-p;
            display: flex;
            justify-content: center;
            align-items: center;
            padding-top: 4rem;
        }
    }

    .close-btn {
        //background-image: url("~@/assets/img/icon/ic_close_black_m.png");
        width: 2.5rem;
        height: 2.5rem;
        background-size: 100%;
        background-repeat: no-repeat;
        cursor: pointer;
        left: 2rem;
        top: 1.6rem;
        position: fixed;
        z-index: 1;
    }

    .qr-guide-text {
        @include title-m;
        padding-top: 1.5rem;
    }
}
</style>

<script>
import {ArrowDown} from "@element-plus/icons-vue";
import {useStore} from "vuex";
import {computed} from "vue";
import router from "@/router";

export default {
    name: "headerComp",
    props: {
        menuName: String
    },
    components: {
        ArrowDown
    },
    setup() {
        const store = useStore()
        const userInfo = computed(() => store.getters['basic/userInfo'])
        const userRoles = computed(() => store.getters['basic/userRoles'])

        return {
            userInfo,
            userRoles
        }
    },
    data() {
        return {
        }
    },
    mounted() {
    },
    methods: {
        transformSlotProps(props) {
            const formattedProps = {};

            Object.entries(props).forEach(([key, value]) => {
                formattedProps[key] = value < 10 ? `${value}` : String(value);
            });

            return formattedProps;
        },
    },
    computed: {
        isAuthenticated: function () {
            if (this.userInfo.id === 0) {
                return false;
            }
            return true;
        },
        currencyPath: function () {
            return router.currentRoute.value.path
        },
        isHost: function () {
            return this.userRoles.includes('ROLE_HOST')
        },
        isStore: function () {
            return this.userRoles.includes('ROLE_STORE')
        },
        isHostSub: function () {
            return this.userRoles.includes('ROLE_HOST_SUB')
        },
        isStoreSub: function () {
            return this.userRoles.includes('ROLE_STORE_SUB')
        },
        isMaster: function () {
            return this.userRoles.includes('ROLE_MASTER')
        }
    },
}
</script>
